<script>
import OnboardingLayout from '@/layouts/OnboardingLayout';
import PersonalForm from '@/components/PersonalForm';

export default {
  components: { OnboardingLayout, PersonalForm },
};
</script>

<template>
  <onboarding-layout :current-step="2">
    <personal-form />
  </onboarding-layout>
</template>
